module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/*global define*/\n\ndefine("models/InstrumentPanel", [\n    \'underscore\',\n    \'backbone\'\n], function (_, Backbone) {\n    \'use strict\';\n\n    var InstrumentpanelModel = Backbone.Model.extend({\n  		// An instrument is defined as a view that renders data about\n        defaults: {\n        	currentVessel: undefined,\n        	instruments: undefined\n        },\n        initialize: function(){\n\n        }\n    });\n    return InstrumentpanelModel;\n});\n';

}
return __p
}